import axios from '../helpers/axios'

export const AddTransaction = (token: any, data: any) => {
  return new Promise((resolve, reject) => {
    axios
      // .post(`/transfers/SDK`, data, {
      .post(`/transfers/url`, data, {

        headers: {
          authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response.data)
       
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const ValidateTransfer = (token: any, data: any) => {
  
  return new Promise((resolve, reject) => {
    axios
      .post(`/transfers/validatePayment`, data, {
        headers: {
          authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}


export const userLatsTransfers = (id:string | undefined, token: string | undefined)=>
  axios 
    .post(`transfers/userLatsTransfers`, {userId: id, token: token }, {

       headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
  .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const TransactionsList = (
    id: string | undefined, 
    token: string | undefined,  
    distributionChannel: string | undefined,
    status: string,
  page: number ,
  limit: number ,

  ) =>
  axios
    .post(`/transfers/userTransfers`, {
      userId: id ,
      distributionChannel,
      status,
      page,
      limit,
    },

       {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const RechargeList = (
  id: string | undefined, token: string | undefined,
   status: string, page: number, limit: number
) =>
  axios
    .post(`/recharges/userRechargeList`, 
      {userId:id, status, page, limit},
     { headers: {
        Authorization: token,
        accept: 'application/json',
      },}
      
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })


export const RechargeMobile = (
  id: string | undefined, token: string | undefined, body: any, paymentMode: string | undefined) =>
  axios
    .post(`/recharges/${paymentMode}/createRecharge`, body, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
})

export const Create = (id: string | undefined, token: string | undefined, body: any) =>
  axios

    .post(`/pcs/create`, body, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => response?.data)
    .catch((error) => {
      console.log(error)
    }
    )


export const Products = ( token: string | undefined, body: any) =>
  axios
    .post(`/products`, body, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
})


export const CartePrepayee = (id: string, token:string, carte: string)=>
  axios .get(`/pcs/pcs?providerCode=${carte}`,{
  headers:{
    Authorization: token,
          accept: 'application/json',
        },
      })
      .then((response)=> {
        return response?.data
      })
      .catch((error)=>{
        console.log(error)
      })

  export const getListeCarteprépayée = (
    userId: string | undefined, token: string | undefined,
   status: string, page: number, limit: number)=>
    axios
    .post(`/pcs/userPrepaidList`,
      {userId, status, page, limit},
    {headers:{
      Authorization: token,
      accept: 'application/json',
    }},
    )
    .then((response)=> {
      return response?.data
    })
    .catch((error)=>{
      console.log(error)
    })

  export const VerifAccount = (id: string | undefined, token: string | undefined) =>
    axios
      .get(`users/${id}/kyc-checks/document`, {
        headers: {
          Authorization: token,
          accept: 'application/json',
        },
      })
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        console.log(error)
  })   


  export const updateProfile = (id: string | undefined, token: string | undefined) =>
    axios
      .get(`users/${id}`, {
        headers: {
          Authorization: token,
          accept: 'application/json',
        },
      })
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        console.log(error)
  })   


  export const SearchPromoCodes = (body: any) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/promos/search-promo', body, {
          headers: {
            accept: 'application/json',
          },
        })
        .then(response => {
          resolve(response?.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  export const tracks = async (body: any) => {
  try {
    const response = await axios.post('/tracks/track', body, {
      headers: {
        accept: 'application/json',
      },
    })

    return response.data
  } catch (error) {
    console.error(' tracks error:', error)
    throw error
  }
}

export const getListByCountry = (country: string | undefined, amount: number | undefined) =>
    axios
      .get(`/partners/listByCountry?amount=${amount}&country=${country}`, {
        headers: {
          accept: 'application/json',
        },
      })
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        console.log(error)
  })   

  export const getListByGovernorate = (
    country: string | undefined, amount: number | undefined, governorate: string | undefined
  ) =>
    axios
      .get(`/partners/listByGovernorate?amount=${amount}&country=${country}&governorate=${governorate}`, {
        headers: {
          accept: 'application/json',
        },
      })
      .then((response) => {
        return response?.data
      })
      .catch((error) => {
        console.log(error)
  })
  
  export const getListByCity = (
    country: string | undefined, amount: number | undefined, governorate: string | undefined, city: string | undefined
  ) =>
  axios
    .get(`/partners/listByCity?amount=${amount}&country=${country}&governorate=${governorate}&city=${city}`, {
      headers: {
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
})
